// The inspector slot: a 340 px docked grid column from 768 px up, a full
// width sheet under 767 px (CONTRACT "Responsive"). Content is whatever the
// current view put in the shell (useShell().setInspector); with nothing set
// it prints the empty header so the toggle still has something to show.
// Closing returns focus to whatever opened it, and while the sheet is open the
// two regions it paints over are inert, so Tab stays on what is visible.
import { BottomSheet } from '../ui/BottomSheet';
import { DockedInspector } from '../ui/DockedInspector';
import { SHEET_COVERED_REGIONS } from './regions';
import { useShell } from './ShellContext';
import { SHEET_MAX_WIDTH, useNarrow } from './useNarrow';

export { SHEET_MAX_WIDTH };

export function InspectorSlot() {
  const { inspectorOpen, closeInspector, inspector } = useShell();
  const narrow = useNarrow(SHEET_MAX_WIDTH);
  const title = inspector?.title ?? 'Nothing selected';
  const subtitle = inspector?.subtitle ?? (inspector ? undefined : 'Select a row to inspect it');
  const body = inspector?.body ?? <p className="insp-empty">The inspector fills when a row, node or edge is selected.</p>;
  if (narrow) {
    return (
      <BottomSheet open={inspectorOpen} onClose={closeInspector} title={title} subtitle={subtitle} artwork={inspector?.artwork} coveredRegions={SHEET_COVERED_REGIONS}>
        {body}
      </BottomSheet>
    );
  }
  return (
    <DockedInspector open={inspectorOpen} onClose={closeInspector} title={title} subtitle={subtitle} artwork={inspector?.artwork}>
      {body}
    </DockedInspector>
  );
}
